import { render, staticRenderFns } from "./NodeOnboardingReplaceSectionButton.vue?vue&type=template&id=00f0064f&"
import script from "./NodeOnboardingReplaceSectionButton.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingReplaceSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports